window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-list-preview:not(.in-backend)").forEach(preview => {
    const menuItems = preview.querySelectorAll(".c-menu-item");
    const select = preview.querySelector(".c-select");
    const contentItems = preview.querySelectorAll(".c-list-preview-item");
    let initialOpen = true;
    if (menuItems.length === 0 || !select || contentItems.length === 0) return;
    toggleByIdentifier(menuItems[0].dataset.identifier);
    for (const menuItem of menuItems) {
      menuItem.addEventListener("click", () => toggleByIdentifier(menuItem.dataset.identifier), {
        passive: true
      });
    }
    select.addEventListener("change", () => toggleByIdentifier(select.value), {
      passive: true
    });
    window.addEventListener("resize", adjustHeight, {
      passive: true
    });
    function toggleByIdentifier(identifier) {
      for (const menuItem of menuItems) {
        menuItem.classList.toggle("open", menuItem.dataset.identifier === identifier);
      }
      select.value = identifier;
      for (const contentItem of contentItems) {
        contentItem.classList.toggle("open", contentItem.dataset.identifier === identifier);
      }
      if (!initialOpen) adjustHeight();
      initialOpen = false;
    }
    function adjustHeight() {
      const openItem = [...contentItems].filter(item => item.classList.contains("open"))[0];
      if (!openItem) return;
      const openItemHeight = openItem.querySelector(".c-inner")?.scrollHeight || "0fr";
      for (const contentItem of contentItems) {
        contentItem.style.setProperty("--item-height", `${openItemHeight}px`);
      }
    }
  });
});